import Axios from 'axios';

const urlPublikos = "https://publikosnode.baradinrtllc.com/"

// Helper Functions
const postData = async (data,urlRoot,urlExt) =>{
    const url = urlRoot + urlExt;
    const res = await Axios.post(url,data);
    console.log(res)
    return res.data;
}

const getData = async (urlRoot,urlExt) =>{
    const url = urlRoot + urlExt;
    const res = await Axios.get(url);
    return res.data;
}

export const searchCSR = async(searchString) =>{

    const urlRoot = "https://petrosfa.baradinrtllc.com/"
    const payload = {searchString}
    const temp = await postData(payload,urlRoot, "getClosestCategories"); 
    return temp
}

export const getMtkProfiles = async() =>{

    const urlRoot = urlPublikos
    const payload = {key:"mtkProfiles"}
    const temp = await postData(payload,urlRoot, "getData");
    return temp["data"]
}

export const getCsrData = async() =>{

    const urlRoot = urlPublikos
    const payload = {key:"csrData"}
    const temp = await postData(payload,urlRoot, "getData");
    return temp["data"]
}

export const getCsrReviews = async() =>{

    const urlRoot = urlPublikos
    const payload = {key:"csrReviewsNonChat"}
    const temp = await postData(payload,urlRoot, "getData");
    // return []
    return temp["data"]
}


export const getDataAll = async() =>{

    const dataAll = {}
    dataAll["csr"] = await getCsrData() //bulk of CSR data
    dataAll["mtk"] = await getMtkProfiles()
    dataAll["csrReviews"] = await getCsrReviews() //non-CS Chat reviews

    return dataAll

}